import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useEffect, useState } from "react";
import { FileButton } from "@mantine/core";
import { faImage } from "@fortawesome/pro-regular-svg-icons";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getSelection, $isRangeSelection, $isTextNode, FORMAT_ELEMENT_COMMAND } from "lexical";
import { $createHeadingNode, $createQuoteNode, $isHeadingNode, $isQuoteNode } from "@lexical/rich-text";
import { $createCodeNode, $isCodeNode } from "@lexical/code";
import { $isListNode, INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND } from "@lexical/list";
import { $getSelectionStyleValueForProperty, $patchStyleText, $setBlocksType } from "@lexical/selection";
import { useTranslation } from "react-i18next";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { FormSelect } from "@/components/form";
import { INSERT_IMAGE_COMMAND } from "./images-plugin";
import { INSERT_LAYOUT_COMMAND } from "./layout-plugin";
import { ALIGN_OPTIONS, BLOCK_OPTIONS, COLUMN_OPTIONS } from "./letter-toolbar-options";
import { ToolbarButton } from "./toolbar-controls";
import { LinkInsertButton } from "./link-insert-button";
import { FontSizeStepper, HistoryButtons, InlineFormatButtons } from "./toolbar-icon-buttons";
/** Compact formatting toolbar for the letter editor. */
export function LetterToolbar(_ref) {
  var onImageFile = _ref.onImageFile,
    enableLink = _ref.enableLink;
  var _useLexicalComposerCo = useLexicalComposerContext(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState("paragraph"),
    blockType = _useState[0],
    setBlockType = _useState[1];
  var _useState2 = useState("left"),
    alignment = _useState2[0],
    setAlignment = _useState2[1];
  var _useState3 = useState(16),
    fontSize = _useState3[0],
    setFontSize = _useState3[1];
  var toOptions = function toOptions(options) {
    return options.map(function (option) {
      return {
        value: option.value,
        label: t(option.labelKey, {
          defaultValue: option.defaultLabel
        })
      };
    });
  };
  useEffect(function () {
    return editor.registerUpdateListener(function (_ref2) {
      var editorState = _ref2.editorState;
      editorState.read(function () {
        var selection = $getSelection();
        if (!$isRangeSelection(selection)) return;
        var element = selection.anchor.getNode().getTopLevelElement();
        if ($isHeadingNode(element)) setBlockType(element.getTag());else if ($isQuoteNode(element)) setBlockType("quote");else if ($isCodeNode(element)) setBlockType("code");else if ($isListNode(element)) setBlockType(element.getListType() === "number" ? "ol" : "ul");else setBlockType("paragraph");
        setAlignment((element === null || element === void 0 ? void 0 : element.getFormatType()) || "left");
        setFontSize(parseInt($getSelectionStyleValueForProperty(selection, "font-size", "16px"), 10) || 16);
      });
    });
  }, [editor]);
  var applyBlock = function applyBlock(type) {
    trackEvent(ANALYTICS_EVENTS.LETTER_BLOCK_TYPE);
    if (!type) return;
    editor.focus();
    if (type === "ul") {
      editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
      return;
    }
    if (type === "ol") {
      editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
      return;
    }
    editor.update(function () {
      var selection = $getSelection();
      if (!$isRangeSelection(selection)) return;
      if (type === "h1" || type === "h2" || type === "h3") {
        $setBlocksType(selection, function () {
          return $createHeadingNode(type);
        });
      } else if (type === "quote") {
        $setBlocksType(selection, function () {
          return $createQuoteNode();
        });
      } else if (type === "code") {
        $setBlocksType(selection, function () {
          return $createCodeNode();
        });
      } else {
        $setBlocksType(selection, function () {
          return $createParagraphNode();
        });
      }
    });
  };
  var changeFontSize = function changeFontSize(delta) {
    var next = Math.min(96, Math.max(8, fontSize + delta));
    setFontSize(next);
    editor.focus();
    editor.update(function () {
      var selection = $getSelection();
      if ($isRangeSelection(selection)) $patchStyleText(selection, {
        "font-size": "".concat(next, "px")
      });
    });
  };
  var clearFormatting = function clearFormatting() {
    editor.update(function () {
      var selection = $getSelection();
      if (!$isRangeSelection(selection)) return;
      $setBlocksType(selection, function () {
        return $createParagraphNode();
      });
      selection.getNodes().forEach(function (node) {
        if ($isTextNode(node)) {
          node.setFormat(0);
          node.setStyle("");
        }
      });
    });
  };
  var pickImage = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
      var _t, _t2, _t3;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(!file || !onImageFile)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            trackEvent(ANALYTICS_EVENTS.LETTER_IMAGE);
            _t = editor;
            _t2 = INSERT_IMAGE_COMMAND;
            _context.n = 2;
            return onImageFile(file);
          case 2:
            _t3 = _context.v;
            _t.dispatchCommand.call(_t, _t2, {
              src: _t3
            });
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function pickImage(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "sticky top-0 z-10 flex flex-shrink-0 flex-wrap items-center gap-x-2 gap-y-1 border-b border-sds-base-default bg-sds-base-default pb-2"
  }, /*#__PURE__*/React.createElement(HistoryButtons, {
    editor: editor,
    onClear: clearFormatting
  }), /*#__PURE__*/React.createElement(FormSelect, {
    className: "w-24 flex-shrink-0",
    size: "sm",
    data: toOptions(BLOCK_OPTIONS),
    value: blockType,
    onChange: applyBlock,
    withinPortal: true,
    "aria-label": t("text_style", {
      defaultValue: "Text style"
    }),
    "data-testid": "letter-block-type"
  }), /*#__PURE__*/React.createElement(FontSizeStepper, {
    value: fontSize,
    onChange: changeFontSize
  }), /*#__PURE__*/React.createElement(InlineFormatButtons, {
    editor: editor
  }), /*#__PURE__*/React.createElement(FormSelect, {
    className: "w-24 flex-shrink-0",
    size: "sm",
    data: toOptions(ALIGN_OPTIONS),
    value: alignment,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.LETTER_ALIGN);
      editor.focus();
      editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, value !== null && value !== void 0 ? value : "left");
    },
    withinPortal: true,
    "aria-label": t("alignment", {
      defaultValue: "Alignment"
    }),
    "data-testid": "letter-align"
  }), /*#__PURE__*/React.createElement(FormSelect, {
    className: "w-24 flex-shrink-0",
    size: "sm",
    placeholder: t("columns", {
      defaultValue: "Columns"
    }),
    data: toOptions(COLUMN_OPTIONS),
    value: null,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.LETTER_COLUMNS);
      if (!value) return;
      editor.focus();
      editor.dispatchCommand(INSERT_LAYOUT_COMMAND, value);
    },
    withinPortal: true,
    "aria-label": t("columns", {
      defaultValue: "Columns"
    }),
    "data-testid": "letter-columns"
  }), onImageFile ? /*#__PURE__*/React.createElement(FileButton, {
    accept: "image/jpeg,image/png",
    onChange: function onChange(file) {
      return void pickImage(file);
    }
  }, function (props) {
    return /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: faImage,
      label: t("add_image", {
        defaultValue: "Add image"
      }),
      testId: "letter-image",
      onClick: props.onClick
    });
  }) : null, enableLink ? /*#__PURE__*/React.createElement(LinkInsertButton, null) : null);
}